/* eslint-disable */
/**
 * html5上传控件
 */
import * as util from './util';
import CONST from './const';
// const console = require('./console')
import request from './request';
import Deferred from './lib/Deferred';
import dataURLtoBlob from './lib/dataURLtoBlob';

/**
 * 是否支持html5上传
 */
export const isSupport = function() {
  return window.FileReader;
};

export const uploadVoice = function(voice, opt) {
  console.log('uploadVoice');

  voice = voice || ''; // 语音 base64
  opt = opt || {};

  const defer = new Deferred();
  let file, error, refer;

  opt.iUploadType = opt.iUploadType || 2;

  if (voice instanceof ArrayBuffer) {
    try {
      file = new Blob([voice]);
    } catch (err) {
      error = err;
      file = null;
    }
  } else {
    try {
      voice = voice.replace(/\s/g, '');
      file = dataURLtoBlob(voice);
    } catch (err) {
      error = err;
      file = null;
    }
  }

  if (util.client == 'qq') {
    refer = 'mqq';
  } else if (util.client == 'qzone') {
    refer = 'mqzone';
  }

  if (file && file.size) {
    upload({
      file: file,
      info: {
        cmd: 'FileUploadVoice',
        uin: util.getUin() + '',
        token: opt.token,
        appid: 'touchuan',
        env: opt.env || {
          refer: refer,
        },
        biz_req: {
          iUploadType: opt.iUploadType,
          vReqData: util.getUploadVoiceInfo(opt),
        },
      },
      onProcess: opt.onProcess || function() {},
    })
      .done(result => {
        defer.resolve(result);
      })
      .fail(result => {
        defer.reject(result);
      });
  } else {
    const errorInfo = {
      ret: -1,
      msg: 'dataURLtoBlob v1 error, ' + error,
      file: '',
    };
    defer.reject(errorInfo);
    console.log(JSON.stringify(errorInfo));
  }

  return defer;
};

/**
 * 通用透传协议
 * base64 [string]
 * opt [object] {
 *	iUploadType [string] 上传类型，必填
 *	reqData [object] 透传数据，必填
 *	token [object] 鉴权token，非必填，默认按p_skey鉴权
 * }
 */
export const uploadTouchuan = function(base64, opt) {
  console.log('uploadTouchuan');

  base64 = base64 || ''; // base64
  opt = opt || {};

  const defer = new Deferred();
  let file, error, refer;

  opt.iUploadType = opt.iUploadType || 0;

  if (base64 instanceof ArrayBuffer) {
    try {
      file = new Blob([base64]);
    } catch (err) {
      error = err;
      file = null;
    }
  } else {
    try {
      base64 = base64.replace(/\s/g, '');
      file = dataURLtoBlob(base64);
    } catch (err) {
      error = err;
      file = null;
    }
  }

  if (util.client == 'qq') {
    refer = 'mqq';
  } else if (util.client == 'qzone') {
    refer = 'mqzone';
  }

  if (file && file.size) {
    upload({
      file: file,
      info: {
        cmd: 'FileUploadTouchuan',
        uin: util.getUin() + '',
        token: opt.token,
        appid: 'touchuan',
        env: opt.env || {
          refer: refer,
        },
        biz_req: {
          iUploadType: opt.iUploadType,
          vReqData: opt.reqData,
        },
      },
      onProcess: opt.onProcess || function() {},
    })
      .done(result => {
        defer.resolve(result);
      })
      .fail(result => {
        defer.reject(result);
      });
  } else {
    const errorInfo = {
      ret: -1,
      msg: 'dataURLtoBlob v1 error, ' + error,
      file: '',
    };
    defer.reject(errorInfo);
    console.log(JSON.stringify(errorInfo));
    console.log('error base64: ' + base64);
  }

  return defer;
};

/**
 * File [array | string]
 */
export const uploadFile = function(file, opt) {
  console.log('uploadFile');

  let index = 0;
  let isFile = false;
  const defer = new Deferred();
  const result = [];
  let files;

  if (Object.prototype.toString.call(file) === '[object File]') {
    files = [file];
    isFile = true;
  } else {
    files = file;
  }

  opt = opt || {};
  opt.iBatchID = opt.iBatchID || +new Date() * 1000;
  opt.mutliPicInfo = {
    iBatUploadNum: files.length,
    iCurUpload: index,
    iSuccNum: 0,
    iFailNum: 0,
  };

  uploadFile();

  function uploadFile() {
    opt = opt || {};

    const waitCount = 2;
    let doneCount = 0;
    let meta = {};
    const file = files[index];
    const img = new Image();
    const _URL = window.URL || window.webkitURL;

    if (file) {
      // 加载宽高
      img.onerror = img.onload = upload;
      img.src = _URL.createObjectURL(file);

      // 加载 meta 信息
      util.getImageMeta(file, data => {
        meta = data;
        upload();
      });
    }

    function upload() {
      doneCount++;
      if (doneCount < waitCount) return;

      upload({
        file: file,
        info: {
          uin: util.getUin() + '',
          token: opt.token,
          env: opt.env || {
            refer: 'huodong',
          },
          biz_req: util.getUploadPicInfo(
            util.extend(
              true,
              {
                iUploadType: 3,
                iAlbumTypeID: 22, // 隐藏相册
                iPicWidth: img.width || 0,
                iPicHight: img.height || 0,
                meta: meta,
              },
              opt,
            ),
          ),
        },
        onProcess: opt.onProcess || function() {},
      })
        .done(result => {
          opt.mutliPicInfo.iSuccNum++;
        })
        .fail(result => {
          opt.mutliPicInfo.iFailNum++;
        })
        .always(res => {
          result.push(res);
          index++;

          if (index < files.length) {
            opt.mutliPicInfo.iCurUpload = index;
            upload();
          } else {
            // 传的是单个文件的话就直接返回结果不返回数组了
            if (isFile) {
              if (result[0] && result[0].ret === 0) {
                defer.resolve(result[0]);
              } else {
                defer.reject(result[0]);
              }
            } else {
              defer.resolve(result);
            }
          }
        });
    }
  }

  return defer;
};

/**
 * base64 [array | string]
 */
export const uploadBase64 = function(base64, opt) {
  console.log('uploadBase64');

  let index = 0;
  let isString = false;
  const defer = new Deferred();
  const result = [];

  if (util.isString(base64)) {
    base64 = [base64];
    isString = true;
  }

  opt = opt || {};
  opt.iBatchID = opt.iBatchID || +new Date() * 1000;
  opt.mutliPicInfo = opt.mutliPicInfo || {
    iBatUploadNum: base64.length,
    iCurUpload: index,
    iSuccNum: 0,
    iFailNum: 0,
  };

  uploadImage();

  function uploadImage() {
    const imgDefer = new Deferred();
    const metaDefer = new Deferred();
    let meta = {};
    const img = new Image();
    let imgData = '';
    let file;
    let error = '';

    try {
      imgData = base64[index].replace(/\s/g, '');
      file = dataURLtoBlob(imgData);
    } catch (err) {
      error = err;
      file = null;
    }

    if (file) {
      // 加载宽高
      img.onerror = img.onload = imgDefer.resolve;
      img.src = imgData;

      // 加载 meta 信息
      util.getImageMeta(file, metaData => {
        meta = metaData;
        metaDefer.resolve();
      });
    } else {
      const errorInfo = {
        ret: -1,
        msg: 'dataURLtoBlob v1 error, ' + error,
        file: '',
      };
      defer.reject(errorInfo);
      console.log(JSON.stringify(errorInfo));
      console.log('error base64: ' + base64);
    }

    Deferred.when(imgDefer, metaDefer).done(_ => {
      upload({
        file: file,
        info: {
          uin: opt.uin || util.getUin() + '',
          appid: opt.appid,
          token: opt.token,
          env: opt.env || {
            refer: 'huodong',
          },
          biz_req: util.getUploadPicInfo(
            util.extend(
              true,
              {
                iUploadType: 3,
                iAlbumTypeID: 22, // 隐藏相册
                iPicWidth: img.width || 0,
                iPicHight: img.height || 0,
                meta: meta,
              },
              opt,
            ),
          ),
        },
        onProcess: opt.onProcess || function() {},
      })
        .done(result => {
          opt.mutliPicInfo.iSuccNum++;
        })
        .fail(result => {
          opt.mutliPicInfo.iFailNum++;
        })
        .always(res => {
          result.push(res);
          index++;

          console.log(`uploadBase64 always index: ${index} total: ${base64.length}`);
          if (index < base64.length) {
            opt.mutliPicInfo.iCurUpload = index;
            upload();
          } else {
            // 传的是字符串的话就直接返回结果不返回数组了
            if (isString) {
              if (result[0] && result[0].ret === 0) {
                console.log('uploadBase64 resolve');
                defer.resolve(result[0]);
              } else {
                console.log('uploadBase64 reject ' + JSON.stringify(base64));
                defer.reject(result[0]);
              }
            } else {
              console.log('uploadBase64 resolve array');
              defer.resolve(result);
            }
          }
        });
    });
  }

  return defer;
};

/**
 * 上传入口
 * @param option
 * @param {string} option.encryptMethod - 加密方法，目前可选为md5|sha
 */
export const upload = function(option) {
  console.log('upload');

  const defer = new Deferred();
  const file = option.file;
  const info = option.info || {};
  const onProcess = option.onProcess || function() {};

  // 空文件直接fail
  if (file && file.size) {
    file.active = false;
    info.check_type = util.getCheckType(option.encryptMethod);

    console.log('encrypt');

    // 计算照片SHA
    onProcess({ step: 0, uploaded: 0, total: file.size });

    request
      .encrypt(file, option.encryptMethod, percent => {
        onProcess({ step: 6, uploaded: 0, total: file.size, encrypt: percent });
      })
      .done((hash = {}) => {
        console.log('encrypt hash ' + hash.hash);

        onProcess({ step: 1, uploaded: 0, total: file.size });

        request
          .controlPacker(file, info, hash)
          .done(control => {
            console.log('controlPacker done');

            if (control.flag === 1) {
              // 命中秒传，直接上传成功
              onProcess({ step: 4, uploaded: 0, total: file.size });

              info.session = info.session || control.session;
              defer.resolve({
                ret: 0,
                msg: 'file quick upload success',
                file: file,
                info: info,
                biz: control.biz,
              });
            } else {
              file.active = true;
              onProcess({ step: 2, uploaded: 0, total: file.size });
              request
                .uploadFile({
                  file: file,
                  info: {
                    cmd: info.cmd,
                    uin: info.uin,
                    appid: info.appid,
                    session: control.session,
                    offset: control.offset || 0,
                    slice_size: control.slice_size,
                    check_type: util.getCheckType(option.encryptMethod),
                    biz_req: {
                      // 传数据这里其实与业务无关的，加上 biz 是为了解包的时候区分
                      iUploadType: info.biz_req && info.biz_req.iUploadType,
                    },
                  },
                  onProcess: onProcess,
                })
                .done(result => {
                  file.active = false;

                  result.info = result.info || {};
                  result.info.session = result.info.session || control.session;

                  console.log('upload resolve');
                  defer.resolve(result);
                })
                .fail(result => {
                  file.active = false;

                  result.info = result.info || {};
                  result.info.session = result.info.session || control.session;

                  if (result.info.flag === 12) {
                    upload(option);
                  } else if (result.info.flag === 13) {
                    option.info.session = '';
                    upload(option);
                  } else {
                    defer.reject(result);
                  }
                });
            }
          })
          .fail(result => {
            defer.reject(result);
          });
      })
      .fail(result => {
        defer.reject(result);
      });
  } else {
    defer.reject({
      ret: CONST.REPORT.FILE_ERROR,
      msg: 'file error',
      file: option.file,
    });
  }

  return defer;
};

export const encrypt = request.encrypt;
